export default "__VITE_ASSET__JIqhUUUW__"